import React from 'react';
import ClubsList from './ClubsList';
import { hikingPath } from '../utils/paths';

/**
 * Hiking-app clubs directory — forces HIKING sport and hiking-app paths.
 */
const HikingClubsList = () => {
  return <ClubsList forcedSport="HIKING" registerPath={hikingPath('/clubs/register')} />;
};

export default HikingClubsList;
